// extracted by mini-css-extract-plugin
export default {"btn":"pagination_btn__eSXZS"};